<template>
    <div class="possibilities" :class="{'possibilities--new': promo.promotion.template === 'payment_structure_v1'}">
        <h2><strong>{{ $t('credits.how_credits_work') }}</strong></h2>

        <ul class="can-do-list mb0">
            <li>
                <div class="icon-wrapper">
                    <svg width="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                </div>
                <div class="list-content">
                    <h3 class="mb-"><strong>{{ $t('credits.unlock_once_title') }}</strong></h3>
                    <p>
                        {{ $t('credits.unlock_once_text_before') }}
                        <span class="clr-gold">{{ $t('credits.credit_count', { count: conversation_price }) }}</span>
                        {{ $t('credits.unlock_once_text_after') }}
                    </p>
                </div>
            </li>
            <li>
                <div class="icon-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21.02"><path data-name="Icon feather-star" d="m11 1 3.09 6.26L21 8.27l-5 4.87 1.18 6.88L11 16.77l-6.18 3.25L6 13.14 1 8.27l6.91-1.01Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                </div>
                <div class="list-content">
                    <h3 class="mb-"><strong>{{ $t('credits.get_noticed_first_title') }}</strong></h3>
                    <p>
                        {{ $t('credits.get_noticed_first_text_before') }}
                        <span class="clr-gold">{{ $t('credits.premium_badge') }}</span>
                        {{ $t('credits.get_noticed_first_text_after') }}
                    </p>
                </div>
            </li>
            <li>
                <div class="icon-wrapper">
                    <svg width="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12,6 12,12 16,14"></polyline></svg>
                </div>
                <div class="list-content">
                    <h3 class="mb-"><strong>{{ $t('credits.no_pressure_title') }}</strong></h3>
                    <p>{{ $t('credits.no_pressure_text') }}</p>
                </div>
            </li>
            <li v-if="false">
                <div class="icon-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.414" height="22.414"><g data-name="Icon feather-image" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path data-name="Path 67" d="M3.222 1h15.556A2.222 2.222 0 0 1 21 3.222v15.556A2.222 2.222 0 0 1 18.778 21H3.222A2.222 2.222 0 0 1 1 18.778V3.222A2.222 2.222 0 0 1 3.222 1Z"/><path data-name="Path 68" d="M8.777 7.111a1.667 1.667 0 1 1-1.666-1.667 1.667 1.667 0 0 1 1.666 1.667Z"/><path data-name="Path 69" d="m21 14.334-5.556-5.556L3.222 21"/></g></svg>
                </div>
                <div class="list-content">
                    <h3 class="mb-">{{ $t('credits.no_pressure_title') }}</h3>
                    <p>{{ $t('credits.no_pressure_text') }}</p>
                </div>
            </li>
        </ul>

    </div>
    <div class="credits-testimonials" v-if="promo.promotion.template === 'payment_structure_v1'">
        <div class="slider-wrapper">
            <div
                v-for="(testimonial, index) in testimonials"
                :key="testimonial.textKey"
                class="item"
                :class="{ active: index === activeTestimonialIndex }"
                :aria-hidden="index !== activeTestimonialIndex"
            >
                <div class="stars">
                    &#9733;&#9733;&#9733;&#9733;&#9733;
                </div>
                <p><i>&quot;{{ $t(testimonial.textKey) }}&quot;</i></p>
                <small>{{ $t(testimonial.authorKey) }}</small>
            </div>
        </div>
    </div>
    <ul class="promotion-benefits" aria-label="Payment benefits" v-if="promo.promotion.template === 'payment_structure_v1'">
        <li class="promotion-benefits__item">
            <span class="promotion-benefits__icon">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
            </span>
            <span>{{ $t('credits.security_ssl') }}</span>
        </li>
        <li class="promotion-benefits__item">
            <span class="promotion-benefits__icon">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
            </span>
            <span>{{ $t('credits.security_pci') }}</span>
        </li>
        <li class="promotion-benefits__item">
            <span class="promotion-benefits__icon">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="1" y="4" width="22" height="16" rx="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
            </span>
            <span>{{ $t('credits.security_cards') }}</span>
        </li>
        <li class="promotion-benefits__item">
            <span class="promotion-benefits__icon">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
            </span>
            <span>{{ $t('credits.security_aws') }}</span>
        </li>
    </ul>
</template>
<script>
    export default {
        name: "PaymentContent",
        props: {
            template: {
                type: Boolean
            },
            promo: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                activeTestimonialIndex: 0,
                testimonialTimer: null,
                testimonials: [
                    {
                        textKey: 'credits.testimonial_markus',
                        authorKey: 'credits.testimonial_markus_author'
                    },
                    {
                        textKey: 'credits.testimonial_thomas',
                        authorKey: 'credits.testimonial_thomas_author'
                    },
                    {
                        textKey: 'credits.testimonial_elena',
                        authorKey: 'credits.testimonial_elena_author'
                    },
                    {
                        textKey: 'credits.testimonial_claudia',
                        authorKey: 'credits.testimonial_claudia_author'
                    },
                    {
                        textKey: 'credits.testimonial_rene',
                        authorKey: 'credits.testimonial_rene_author'
                    },
                    {
                        textKey: 'credits.testimonial_sabine',
                        authorKey: 'credits.testimonial_sabine_author'
                    }
                ]
            }
        },
        created() {
            this.conversation_price = process.env.VUE_APP_UNLOCK_CONVERSATION
            this.gallery_price = process.env.VUE_APP_UNLOCK_GALLERY
        },
        mounted() {
            this.startTestimonialSlider()
        },
        beforeUnmount() {
            clearInterval(this.testimonialTimer)
        },
        methods: {
            startTestimonialSlider() {
                this.testimonialTimer = setInterval(() => {
                    this.activeTestimonialIndex = (this.activeTestimonialIndex + 1) % this.testimonials.length
                }, 10000)
            }
        }
    }
</script>

<style scoped lang="scss">

.credits-testimonials {
    background: $color-credits-gradient1;
    // box-shadow: 0px 0px 12px -3px #bebebe;
    border: 1px solid #bebebe;
    border-radius: 10px;
    padding: 30px;

    .slider-wrapper {
        display: grid;
        overflow: hidden;
    }

    .item {
        grid-area: 1 / 1;
        opacity: 0;
        transition: opacity 0.5s ease, visibility 0.5s ease;
        visibility: hidden;

        &.active {
            opacity: 1;
            visibility: visible;
        }
    }

    .stars {
        color: $color-type19;
        margin-bottom: 20px;

    }

    p {
        color: $color-credits-type2;
        margin-bottom: 20px;
        line-height: 1.3;
    }

    small {
        color: $color-credits-type3;
    }

    @media(max-width: 991px) {
        padding: 20px 20px;
        max-width: calc(100% - 40px);
        margin: 0 auto;
    }
}

.possibilities {
    padding: 80px 100px;
    border-radius: 10px;
    background-color: #fff;
    height: auto;
    overflow: hidden;
    text-align: left;
    border: 1px solid $color-credits-border;
    margin-bottom: 30px;

    &.possibilities--new {
        padding: 30px ;
        border-radius: 10px;
    }

    h2 {
        color: $color-credits-type5;
        font-size: 24px;
        font-weight: 400;
        margin-bottom: 20px;
        text-align: left;
    }

    small {
        font-size: 13px;
        color: #777777;
        line-height: 1.3;
        margin: 20px 0;
        display: block;

        a {
            font-size: 13px;
            line-height: 1.3;
            text-decoration: underline;
        }
    }

    @media(max-width: 991px) {
        padding: 20px;
        max-width: calc(100% - 40px);
        margin: 0 auto 20px;

        h2 {
            margin-bottom: 20px;
            font-size: 20px;
        }

        .list-content {
            h3 {
                font-size: 16px;
            }

            p {
                font-size: 14px;
            }
        }
    }
}


.can-do-list {



    li {
        padding: 20px 0;
        display: flex;
        align-items: flex-start;
    }

    h3 {
        font-size: 18px;
        font-weight: 700;
        letter-spacing: -0.9px;
        margin-bottom: 0;
        color: $color-credits-type5;
    }

    p {
        margin-bottom: 0;
        font-size: 16px;
        line-height: 1.35;
        letter-spacing: 0.07px;
        color: $color-credits-type3;

        span {
            color: $color-type19;
        }
    }

    .icon-wrapper {
        width: 50px;
        min-width: 50px;
        margin-right: 20px;
        height: 50px;
        border-radius: 50%;
        background-color: $color-credits-type6;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            stroke: $color-credits-type1;

            path {
                stroke: $color-credits-type1;
            }
        }

        @media( max-width: 991px) {
            width: 40px;
            min-width: 40px;
            margin-right: 10px;
            height: 40px;
        }
    }

    // @media( max-width: 991px) {
    //     p {
    //         font-size: 14px;
    //     }
    // }
}

.promotion-benefits {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 24px;
    row-gap: 14px;
    width: 100%;
    margin: 30px 0;
    padding: 14px 16px;
    list-style: none;
}

.promotion-benefits__item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.3;
    white-space: nowrap;
    color: $color-credits-type3;
}

.promotion-benefits__icon {
    color: $color-credits-type3;
    font-size: 15px;
    font-weight: 700;
    line-height: 1;
}

@media (max-width: 420px) {
    .promotion-benefits {
        column-gap: 16px;
        padding-inline: 12px;
    }

    .promotion-benefits__item {
        font-size: 12px;
    }
}

.list {
    margin: 0 auto;
    max-width: 600px;

    li {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 1.35;

        svg {
            margin-right: 5px;
            min-width: 22px;
            margin-top: 2px;
        }
    }
}
</style>
